"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FocusRegionManager", {
  enumerable: true,
  get: function () {
    return _FocusRegionManager.default;
  }
});
Object.defineProperty(exports, "focusRegion", {
  enumerable: true,
  get: function () {
    return _FocusRegionDecorator.focusRegion;
  }
});
var _FocusRegionManager = _interopRequireDefault(require("./js/FocusRegionManager"));
var _FocusRegionDecorator = require("./js/FocusRegionDecorator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }